import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArchiveLocked = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M12 9c.87 0 1.67-.38 2.223-1H9.777c.553.62 1.353 1 2.223 1z" fill="none" />
    <path d="M21.5 8a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-19a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5H3v12.5a.5.5 0 0 0 .5.5H12v-1H4V8h4.564c.69 1.19 1.96 2 3.436 2s2.746-.81 3.436-2H20v2h1V8h.5zM12 9c-.87 0-1.67-.38-2.223-1h4.446C13.67 8.62 12.87 9 12 9zM3 7V4h18v3H3z" />
    <path d="M23 16v-2.005A2 2 0 0 0 21 12h-4.004A1.996 1.996 0 0 0 15 13.996V16a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm-6.004-3H21c.551 0 1 .447 1 .995V16h-6v-2.004c0-.55.447-.996.996-.996zM8 12v3h4v-1H9v-1h4v-1z" />
  </SvgIcon>
);

export default ArchiveLocked;
